import { CircularProgress, Grid, Paper } from "@mui/material"
import React, { useContext, useMemo } from "react"
import { Variant1Context } from "../../contexts/Variant1Context"
import { BuildingThresholdRow } from "./components/BuildingThresholdRow"
import { Variant2Context } from "../../contexts/Variant2Context"
import { DashboardSectionTitle } from "../../../../../../../../components/charts/components/DashboardSectionTitle"

export function CompareVariantTopPanel(): React.JSX.Element {
  const { bsBuilding1, bsBuildingResult1, isBuildingLoading1, isBuildingResultLoading1 } = useContext(Variant1Context)
  const { bsBuilding2, bsBuildingResult2, isBuildingLoading2, isBuildingResultLoading2 } = useContext(Variant2Context)

  const maxValue = useMemo(
    () =>
      Math.max(bsBuildingResult1?.carbonImpactTotalPerSurface ?? 0, bsBuildingResult2?.carbonImpactTotalPerSurface ?? 0) *
      1.3,
    [bsBuildingResult1?.carbonImpactTotalPerSurface, bsBuildingResult2?.carbonImpactTotalPerSurface]
  )

  return (
    <Paper>
      <DashboardSectionTitle label="Seuil RE2020" />
      <Grid container sx={{ p: 2 }}>
        {isBuildingLoading1 && isBuildingResultLoading1 ? (
          <CircularProgress />
        ) : (
          <BuildingThresholdRow bsBuilding={bsBuilding1} bsBuildingResult={bsBuildingResult1} maxValue={maxValue} />
        )}
        {isBuildingLoading2 && isBuildingResultLoading2 ? (
          <CircularProgress />
        ) : (
          <BuildingThresholdRow bsBuilding={bsBuilding2} bsBuildingResult={bsBuildingResult2} maxValue={maxValue} />
        )}
      </Grid>
    </Paper>
  )
}
